import { fetcher } from '@commenda/utils';
import { File } from '@prisma/client';
import { useQuery } from '@tanstack/react-query';

const getDocuments = async (businessEntityId: number) => {
  const response = await fetcher(`document?corporationId=${businessEntityId}`, {
    method: 'GET',
  });

  if (!response.ok) throw new Error('Failed to fetch business entity');

  return (await response.json()) as File[];
};

const businessEntityKeys = {
  FETCH_DOCUMENTS: 'FETCH_DOCUMENTS',
};

const useDocuments = (businessEntityId: number) => {
  return useQuery({
    queryKey: [businessEntityKeys.FETCH_DOCUMENTS, { businessEntityId }],
    queryFn: () => getDocuments(businessEntityId),
  });
};

export { useDocuments };
